import { useEffect } from 'react';

const TawkToWidget = () => {
  useEffect(() => {
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    (function () {
      var s1 = document.createElement('script');
      var s0 = document.getElementsByTagName('script')[0];
      s1.async = true;
      s1.src = 'https://embed.tawk.to/68a8c6abce17d419321e5e18/1j39kg3r6';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      s0.parentNode.insertBefore(s1, s0);
    })();

    window.Tawk_API.onLoad = function () {
      window.Tawk_API.customStyle = {
        visibility: {
          desktop: {
            position: 'tl',
            xOffset: '20px',
            yOffset: '20px'
          },
          mobile: {
            position: 'tl',
            xOffset: '20px',
            yOffset: '20px'
          }
        },
        bubble: {
          rotate: '0deg',
          xOffset: '-20px',
          yOffset: '0px'
        }
      };
    };
  }, []);

  return null;
};

export default TawkToWidget;
